import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LogyardTypeService } from '../proxy/planning/controllers/logyard-type.service';
import { ZoneService } from '../proxy/planning/controllers/zone.service';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { MeasurementTypeService } from '@woodsupply/proxy/wood-supply/controllers/measurement-type.service';

import { CostCenterByLocation } from '../cost-center-by-location/cost-center-by-location';
FieldBuilder.setNamespace('Planning');

export const LOGYARD_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Logyard.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .number('capacity', 'Entity.Logyard.Capacity')
    .decimal(2,9)
    .build(),
  FieldBuilder
    .checkbox('isEligibleForElectronicInvoice', 'Entity.Logyard.IsEligibleForElectronicInvoice')
    .build(),
  FieldBuilder
    .checkbox('isDestinationWoodLog', 'Entity.Mill.IsDestinationWoodLog')
    .build(),
  FieldBuilder
    .checkbox('isTransferLogyard', 'Entity.Logyard.IsTransferLogyard')
    .build(),
  FieldBuilder
    .checkbox('demandSaleContract', 'Entity.Logyard.DemandSaleContract')
    .build(),
  FieldBuilder
    .text('remsoftName', 'Entity.Logyard.RemsoftName')
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('measurementTypeId', 'Entity.Logyard.MeasurementType', MeasurementTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.Logyard.IsActive')
    .build(),
  FieldBuilder
    .foreignKey('logyardTypeId', 'Entity.LogyardType', LogyardTypeService)
    .required()
    .displayFromNested('logyardType.name')
    .sortBy('logyardType.name')
    .build(),
  FieldBuilder
    .foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .displayFromNested('zone.name')
    .sortBy('zone.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const LOGYARD_CONFIG = {
  entityName: 'Logyard',
  localizationKey: 'Planning::Entity.Logyard',
  permission: 'PlanningLocation.Logyards',
  fields: LOGYARD_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'CostCenterByLocation',
      foreignKeyField: 'locationId',
      localizationKey: 'Planning::Entity.CostCenterByLocation',
      component: CostCenterByLocation,
    },
  ],
};
